// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"Vm","result_page":"Wm","what_are_calories":"Xm","title":"Ym","copy":"Zm","chart":"an","to_reach":"bn","title_wrapper":"cn","rhode_percent":"en","what_are_macro":"fn","text":"gn","img":"hn","macros_wrapper":"in","macros":"jn","macro_item":"kn","value":"ln","note":"mn","btn":"nn","carbo_item":"on","faq":"pn","faq_items":"qn"};
    if(module.hot) {
      // 1743628918761
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  